import { Component, Inject, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DialogRef } from '../../aero/aero-dialog/types';

/**
 * Component for adding or applying a coupon code through a dialog interface.
 * Provides input field for promo code entry with validation and AJAX support.
 * Manages dialog state based on input validity and handles value change events.
 */
@Component({
  selector: 'bulb-apply-promo-code',
  template: `
    <aero-input
      type="text"
      name="promoCode"
      [autofocus]="true"
      bulbValidationField
      bulbAjaxValidation="promoCode"
      [bulbAjaxValidationOptions]="{ position: config.data?.position }"
      [label]="'account_settings_promo_code' | translate"
      [(ngModel)]="promoCode"
      (aeroInputNgModelEmitter)="onModelChange($event)"
      (ngModelChange)="onChange()"
      [required]="true">
    </aero-input>
  `,
  standalone: false,
})
export class AddCouponComponent implements OnInit {
  promoCode = '';

  /**
   * Creates a new instance of the component with injected dependencies.
   * @param dialogRef The reference to the dialog instance for managing its lifecycle and communication
   * @param config The configuration object containing dialog settings and data passed to the dialog
   * @return Initializes a new dialog component instance with the provided dependencies
   */
  constructor(
    @Inject('DialogRef') private dialogRef: DialogRef,
    public config: DynamicDialogConfig,
  ) {}

  /**
   * Initializes the component and sets up the dialog configuration.
   * Disables the primary button in the dialog.
   *
   * @return {void}
   */
  ngOnInit(): void {
    this.dialogRef.setPrimaryDisabled(true);
  }

  /**
   * Automatically disables the dialog's primary button if empty,
   * while AJAX is pending, or if the coupon/promo code is invalid.
   */
  onModelChange(model: any): void {
    if (model) {
      this.dialogRef.setPrimaryDisabled(model.invalid || model.pending);
    }
  }

  /**
   * Handles the change event for the promo code input.
   * Invokes the valueChange callback function if it exists in the configuration data,
   * passing the current promo code value as an argument.
   *
   * @return {void}
   */
  onChange(): void {
    if (this.config.data?.valueChange) {
      this.config.data.valueChange(this.promoCode);
    }
  }
}
